import React, { PropsWithChildren } from 'react';

import { Spinner } from '@provider-portal/common/components/Spinner';
import GenericError, {
  GenericErrorType,
} from '@provider-portal/menu-common/components/GenericError/GenericError';

import { DataFetcher } from 'hooks/apiFetcher/createFetcher';

interface FetcherStateViewProps<Data, Error> {
  fetcher: Omit<DataFetcher<Data, unknown[], Error>, 'fetch'>;
  stringIds: {
    empty: string;
    error: string;
  };
}

export const FetcherStateView = <Data, Error>({
  fetcher,
  stringIds,
  children,
}: PropsWithChildren<FetcherStateViewProps<Data, Error>>) => {
  if (fetcher.isFetching) {
    return <Spinner />;
  }
  if (fetcher.error) {
    return <GenericError type={GenericErrorType.error} intlIdTitle={stringIds.error} />;
  }
  if (!fetcher.data) {
    return <GenericError type={GenericErrorType.info} intlIdTitle={stringIds.empty} />;
  }
  return <>{children}</>;
};
